import React, { useEffect } from "react";
import FieldDescription from "../tools/FieldDescription";
import { isValidRcs } from "../../utils/functions/validateRCSNumber";
import { fetchCompanyDetailsByRcs } from "../../utils/functions/fetchCompanyDetailsByRcs";
import useValidation from "../../hooks/useValidation";
import RcsInput from "./RcsInput2";
import { CompanyNameType } from "../../static/types/commonTypes/companyNameType";
import reducedLegalEntityValidationSchema from "../../utils/validation/reducedLegalEntityValidationScheme";
import { ReducedLegalEntityType } from "../../static/types/commonTypes/reducedLegalEntityType";

type LegalEntityProps = {
    checked: boolean,
    reducedLegalEntity: ReducedLegalEntityType,
    companyName?: CompanyNameType,
    setCompanyName?: (data: Partial<CompanyNameType>) => void,
    changeReducedLegalEntity: (data: Partial<ReducedLegalEntityType>) => void,
    onValidationChange: (isValid: boolean) => void
};

export default function ReducedLegalEntity({
    checked,
    reducedLegalEntity,
    companyName,
    setCompanyName,
    changeReducedLegalEntity,
    onValidationChange
}: LegalEntityProps) {

    const { errors, isValid } = useValidation(reducedLegalEntity, reducedLegalEntityValidationSchema);

    useEffect(() => {
        console.log('[Validation] reducedLegalEntity:', reducedLegalEntity);
        console.log('[Validation] isValid:', isValid);
        onValidationChange(isValid);
    }, [isValid, onValidationChange, reducedLegalEntity]);

    const handleRcsChange = async (rcsValue: string) => {
        console.log('[RCS] Input changed:', rcsValue);

        // Mise à jour immédiate du RCS
        changeReducedLegalEntity({ ...reducedLegalEntity, rcs: rcsValue });
        console.log('[RCS] Updated reducedLegalEntity with RCS:', { ...reducedLegalEntity, rcs: rcsValue });

        // Si le RCS est valide, récupérer les détails
        if (isValidRcs(rcsValue)) {
            try {
                console.log('[RCS] RCS is valid, fetching company details...');
                const companyDetails = await fetchCompanyDetailsByRcs(rcsValue);
                console.log('[RCS] Fetched company details:', companyDetails);

                if (companyDetails) {
                    // Ne pas écraser le RCS saisi
                    const updatedEntity = { ...companyDetails, rcs: rcsValue };
                    changeReducedLegalEntity(updatedEntity);
                    console.log('[RCS] Updated reducedLegalEntity with fetched data:', updatedEntity);

                    if (setCompanyName) {
                        setCompanyName({ ...companyName, companyName: companyDetails.companyName });
                        console.log('[RCS] Updated companyName:', { ...companyName, companyName: companyDetails.companyName });
                    }
                }
            } catch (error) {
                console.error('[RCS] Error fetching company details:', error);
            }
        }
    };

    return (
        <div className="mb-3 row">
            <RcsInput
                checked={checked}
                errors={errors}
                rcs={reducedLegalEntity.rcs || ""}
                onChange={handleRcsChange}
            />

            <label htmlFor="denomination1" className="col-sm-2 col-form-label required">
                Dénomination <strong className="text-danger">*</strong>
            </label>

            <div className="col-sm-4">
                <input
                    className={`description-input form-control ${(checked && errors.companyName) ? 'is-invalid' : ''}`}
                    type="text"
                    name="companyName"
                    id="companyName"
                    value={(companyName?.companyName || reducedLegalEntity.companyName) ?? ''}
                    onChange={event => {
                        const value = event.target.value;
                        console.log('[CompanyName] Input changed:', value);

                        if (setCompanyName) {
                            setCompanyName({ ...companyName, companyName: value });
                            changeReducedLegalEntity({ ...reducedLegalEntity, companyName: value });
                        } else {
                            changeReducedLegalEntity({ ...reducedLegalEntity, companyName: value });
                        }
                    }}
                />
                {checked && errors.companyName && <div className="invalid-feedback">{errors.companyName}</div>}
                <FieldDescription description="Nom de la société, comme mentionné dans les statuts." />
            </div>
        </div>
    );
}
